import React from 'react';
import styled from 'styled-components';

export const MenuIcon = props => (
  <svg viewBox="2.432 1.39 11.136 10.02" {...props}>
    <path d="M9.561,7.2c0.441,0,0.8-0.358,0.8-0.8s-0.358-0.8-0.8-0.8H3.232c-0.442,0-0.8,0.358-0.8,0.8s0.358,0.8,0.8,0.8H9.561z" />
    <path
      d="M13.568,2.19c-0.002-0.441-0.359-0.798-0.801-0.8H3.232c-0.442,0-0.8,0.358-0.8,0.8s0.358,0.8,0.8,0.8h9.536
	C13.208,2.985,13.562,2.63,13.568,2.19z"
    />
    <path
      d="M3.232,11.41h4.167c0.442,0,0.8-0.358,0.8-0.801c0-0.441-0.358-0.799-0.8-0.799H3.232c-0.442,0-0.8,0.357-0.8,0.799
	C2.432,11.052,2.79,11.41,3.232,11.41z"
    />
  </svg>
);

MenuIcon.displayName = 'MenuIcon';

export default styled(MenuIcon)``;



// WEBPACK FOOTER //
// ./src/components/MenuIcon.js